// src/main.ts
import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router, { initRouter } from './router';
import { setupStore } from '@/store'; // ← 改这里
import { i18n } from '@/plugins';
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig';
import { CommonUtils } from '@/utils/commonUtils';
import { MotionPlugin } from '@vueuse/motion';
import 'element-plus/dist/index.css';
import { IconifyIconOffline, IconifyIconOnline, FontIcon } from './components/ReIcon';

(window as any).$i18n = i18n;

async function bootstrap() {
  const app = createApp(App);
  /* 1. 先把 Pinia 装到 app 上 */
  setupStore(app);
  await initRouter();
  /* 2. 再装路由、i18n 等其它插件 */
  app.use(router);
  /* 3. 现在可以安全地调用 useSystemConfigStoreHook() */
  const sysStore = useSystemConfigStoreHook();
  await sysStore.getSystemConfig();
  await router.isReady();
  app.use(MotionPlugin);
  app.use(i18n);

  app.component('IconifyIconOffline', IconifyIconOffline);
  app.component('IconifyIconOnline', IconifyIconOnline);
  app.component('FontIcon', FontIcon);
  console.log('当前语言：', i18n.global.locale);

  /* 4. 同步语言到 i18n & <html lang> */
  i18n.global.locale.value = sysStore.currentLang;
  // document.documentElement.setAttribute('lang', sysStore.currentLang)

  /* 5. 应用主题与 favicon */
  CommonUtils.applyTheme();
  if (sysStore.commonConfig.logoUrl) {
    CommonUtils.changeFavicon(sysStore.commonConfig.logoUrl);
  }

  /* 6. 挂载应用 */
  app.mount('#app');
}

bootstrap();
